import {environment} from '../../../environments/environment';
import {Component, OnDestroy, OnInit} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {ActivatedRoute} from '@angular/router';
import {HttpClient, HttpHeaders, HttpResponse} from '@angular/common/http';
import {AuthenticationService} from '../../core/services';


@Component({
    selector: 'app-bundle-downloader',
    templateUrl: './bundle-downloader.component.html',
    styleUrls: ['./bundle-downloader.component.scss'],
})
export class BundleDownloaderComponent implements OnInit, OnDestroy {

    private routerSubscription: Subscription;
    private bundleId: string;

    readonly bundleUrl = (bundleId: string) => `${environment.backendUrl}/invoicestore/app/api/bundles/${bundleId}`;

    constructor(private route: ActivatedRoute,
                private http: HttpClient,
                private authenticationService: AuthenticationService) {
        this.getRouterParams();
    }

    ngOnInit(): void {

        const url = this.bundleUrl(this.bundleId);

        // Step 1: Get the signed URL from the backend
        this.http.get(url, {responseType: 'text'}).subscribe(
            (retrievedUrl: string) => {
                // Step 2: Redirect directly to the signed URL
                window.location.href = retrievedUrl; // Browser handles CORS preflight automatically if needed
            },
            (error) => {
                console.error('Error fetching the signed URL:', error);
            }
        );


    }

    private downloadBundleById(bundleId: string): Observable<HttpResponse<Blob>> {
        const headers = new HttpHeaders()
            .set('Accept', '*/*')
            .set('Authorization', `Bearer ${this.authenticationService.getUserToken()}`);
        return this.http.get(this.bundleUrl(bundleId), {
            headers,
            observe: 'response',  // Ensure response includes headers
            responseType: 'blob'   // Blob type to handle binary data
        });
    }

    private getRouterParams(): void {
        this.routerSubscription = this.route.paramMap.subscribe((params) => {
            this.bundleId = params.get('bundleId');
        });
    }

    ngOnDestroy(): void {
        this.routerSubscription.unsubscribe();
    }


}